module.exports = __webpack_public_path__ + "static/media/priority_shipping.987a8e65.png";